<template>
    <div class="content-header">
        <div class="row-fluid">
            <bar-loader v-if="company.company[0] == null" class="custom-class" color="#6d0606" loading="loading" :size="150" sizeUnit="px"></bar-loader>
            <b-input-group v-else>
                <label  v-if="company.company[0].accounts.length > 1" class="mt-2 mr-0" for="acc">Select Account:</label>
                <select  v-if="company.company[0].accounts.length > 1" id="acc" v-model="account" style="border-color: transparent;" class="form-control my-select">
                    <option v-for="account in company.company[0].accounts" :value="account.accNumber" v-bind:key="account.accNumber">{{account.accNumber}} - {{account.accName}}</option>
                </select>
                <p  v-if="company.company[0].accounts.length < 2" class="mt-2 mr-0">AccountNumber: {{company.company[0].accounts[0].accNumber}} <span class="d-none d-sm-inline">- {{company.company[0].accounts[0].accName}}</span></p>
            </b-input-group>
        </div>

        <nav class="nav">
            <a href="#" @click="logout()" class="nav-link"><i data-feather="log-out"></i></a>
            <a href="#" @click="startTour()" class="nav-link"><i data-feather="help-circle"></i></a>
        </nav>
<!--        <v-tour name="myTour" :steps="steps"></v-tour>-->
    </div><!-- content-header -->
</template>

<script>
    import {mapState} from 'vuex'
    //import { genUserBaseUrl } from "src/app.config";

    export default {
        name: "Header",
        components:{

        },
        data(){
            return{
                acc:'',
                getDropdownValues:'',
                validateSelection:'',
                model:{
                    account:'01893098999'
                },
                accounts:[
                    { id: 1, name: 'Option 1'},
                    { id: 2, name: 'Option 2'}
                ]
            }
        },
        methods:{
            officerFilteredByUserId(_item) {
                return this.officer.officers.filter(function (el) {
                    return el.officerUserID == _item;
                });
            },
            async initDashboard(){
                //console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>calling')
                this.$store.commit('system/updateAppLoading', true);
                await this.$store.dispatch("system/updateUserInfo", {payload:"you"}, { root: false });
                if(this.system.userInfo != null) await this.$store.dispatch("company/updateCompanies", {
                    userID: this.system.userInfo.id,
                    requestType: 'company'
                }, { root: false });
                else this.$router.push('/');
                if(this.system.userInfo != null) await this.$store.dispatch("system/updateDashboard", {
                    orgID: localStorage.orgID,
                    userID: this.system.userInfo.id,
                    accID: localStorage.accID,
                    requestType: 'dashboard'
                }, {root: true});
                await this.$store.dispatch("officer/updateOfficers", {
                    orgID: localStorage.orgID,
                    accID: localStorage.accID,
                    requestType: 'officer'
                }, {root: true});
                //console.log(this.company.account[0]);
                this.$store.dispatch("logs/readFtLogs", {
                    customerId: this.company.account[0].accCustID
                }, {root: true});
                this.$store.dispatch("logs/readNeLogs", {
                    customerId: this.company.account[0].accCustID
                }, {root: true});
                this.$store.dispatch("setting/getApiKey", {
                    apiKeyAccountNumber: this.company.account[0].accNumber,
                    env: 'prod'
                }, {root: true});
                this.$store.commit('system/updateAppLoading', false);
                if (this.officerFilteredByUserId(this.system.userInfo.id)[0] != null)
                    if (
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerPassportURL === '' ||
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerPassportURL == null ||
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerSignatureURL === '' ||
                        this.officerFilteredByUserId(this.system.userInfo.id)[0].officerSignatureURL == null
                    ){
                        const options = {title: 'Warning!', size: 'sm'}
                        this.$dialogs.alert('Please complete your officer profile for this account', options)
                            .then(res => {
                                console.log(res) // {ok: true|false|undefined}
                                this.$router.push('/officer-profile')
                            })
                    }

            },
            logout(){
                localStorage.clear();
                window.location = '/';
            },
            startTour(){
                this.$tours['myTour'].start()
            }
        },
        computed:{
            ...mapState([
                'company',
                'officer',
                'system'
            ]),
            account: {
                get() {
                    //return localStorage.accNumber;
                    if (this.company.acc === '')
                        return localStorage.accNumber;
                    else
                        return this.company.acc
                },
                set(val) {
                    localStorage.accNumber = val;
                    this.$store.commit("company/updateAcc",val);
                    this.initDashboard();
                }
            }
        },
        mounted() {
            //$('.my-select').selectpicker();
        }
    }
</script>

<style scoped>

</style>